// import React from 'react';
// import "../css-coding/TestimonialSection.css";

// import c1 from "../assets/c1.png";
// import c2 from "../assets/c2.png";
// import c3 from "../assets/avatar9.png";
// import c4 from "../assets/c4.png";
// import c5 from "../assets/avatar2.jpg";
// import c6 from "../assets/avatar6.png";
// import c7 from "../assets/avatar7.jpg";
// import c8 from "../assets/c8.png";
// import c9 from "../assets/avatar1.png";
// import c10 from "../assets/c10.png";
// import c11 from "../assets/c11.png";
// import c12 from "../assets/c12.png";
// import c13 from "../assets/c13.png";
// import c14 from "../assets/avatar8.png";
// import c15 from "../assets/avatar10.png";

// const testimonialsTop = [
//   {
//     text: "Your quality of work and 24/7 support straight-up boosted my sales. Thanks,fam!",
//     user: "Shanmuga Priya Baskar, Founder of Saibariya Skin & Haircare",
//     img: c1
//   },
//   {
//     text: "Your Agency's work generated significant leads for our business. We highly recommend your services to Other Also. Thank You !",
//     user: "A1 Bricks, Coimbatore",
//     img: c2
//   },
//   {
//     text: "Your editing style helped me reach a large audience and gain followers quickly. I'm truly grateful!",
//     user: "Ram Kumar, Founder of BBQ Mechanic",
//     img: c3
//   },
//    {
//     text: "Suberb Edit Bro. Keep Rocking Always",
//     user: "Bharath Ganesh, Founder of Social Sphere",
//     img: c8
//   },
//    {
//     text: "I've Seen your recent works. Looks Cool Bro",
//     user: "Kennet Alphy, Founder of Goat Media",
//     img: c9
//   },
//    {
//     text: "Excellent Edit Bro.Thanks for your creative edit bro",
//     user: "Founder of Meet my Mentor",
//     img: c10
//   },

//    {
//     text: "Thank you Prakash for your hardwork on editing and shooting. Keep Doing More!",
//     user: "Sweattha Subramani, CEO at Subramanya Educational Institutions",
//     img: c11
//   },
// ];

// const testimonialsBottom = [
//   {
//     text: "Impressed by your on-time delivery and high-quality product shoots. Thank You.",
//     user: "Gokul Krishna, Founder of G Krishna Naturals",
//     img: c4
//   },
//   {
//     text: "I’ve seen your works and truly loved the creativity and effort you put in. Keep rocking bro, your content always stands out!",
//     user: "Ashwin R, Founder of Ashtag",
//     img: c5
//   },
//   {
//     text: "Bro, your edits are next level, super clean and engaging. Can’t wait to see where your talent takes you!",
//     user: "Sharan Raj Kumar, Founder of Dike DigitalJourney",
//     img: c6
//   },
//   {
//     text: "Loved your works bro, Superb",
//     user: "Epaphra, Founder of Townscholar",
//     img: c7
//   },
//   {
//     text: "Thanks for your promo video brother. Video Excellent ah Vandhuruku",
//     user: "Founder of Aiswaryam Oils",
//     img: c12
//   },

//   {
//     text: "Pakka va iruku Bro Reel. Thanks for your work team",
//     user: "Thufyl, Managing Director of Fathima Jewellery",
//     img: c13
//   },
//   {
//     text: "Bro , Excellent Edit. Super ah iruku",
//     user: "Dr Thamizhinian , Certified Dermatologist",
//     img: c14
//   },
//   {
//     text: "Prakash Our Video Reached 3Million+ Views. Thanks for your team work guys",
//     user: "Rajees, Founder of Rajees Makeover",
//     img: c15
//   },
 
// ];

// const TestimonialSection = () => {
//   return (
//     <section className="testimonial-wrapper" id="testimonials">
//       <p className="testimonial-badge">Reviews</p>
//       <h2 className="testimonial-heading">Real Stories, Real Results</h2>

    
//       <div className="marquee-wrapper">
//         <div className="marquee-track left">
//           {[...testimonialsTop, ...testimonialsTop].map((item, index) => (
//             <div key={index} className="testimonial-card">
//               <div className="stars">★★★★★</div>
//               <p className="testimonial-text">{item.text}</p>
//               <div className="testimonial-user-info">
//                 <img src={item.img} alt="User avatar" />
//                 <p className="testimonial-user">{item.user}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

     
//       <div className="marquee-wrapper">
//         <div className="marquee-track right">
//           {[...testimonialsBottom, ...testimonialsBottom].map((item, index) => (
//             <div key={index} className="testimonial-card">
//               <div className="stars">★ ★ ★ ★ ★</div>
//               <p className="testimonial-text">{item.text}</p>
//               <div className="testimonial-user-info">
//                 <img src={item.img} alt="User avatar" />
//                 <p className="testimonial-user">{item.user}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

      
//     </section>
//   );
// };

// export default TestimonialSection;

import { useState, useEffect } from 'react';
import "../css-coding/TestimonialSection.css";

import c1 from "../assets/c1.png";
import c2 from "../assets/c2.png";
import c3 from "../assets/avatar9.png";
import c4 from "../assets/c4.png";
import c5 from "../assets/avatar2.jpg";
import c6 from "../assets/avatar6.png";
import c7 from "../assets/avatar7.jpg";
import c8 from "../assets/c8.png";
import c9 from "../assets/avatar1.png";
import c10 from "../assets/c10.png";
import c11 from "../assets/c11.png";
import c12 from "../assets/c12.png";
import c13 from "../assets/c13.png";
import c14 from "../assets/avatar8.png";
import c15 from "../assets/avatar10.png";

const testimonialsTop = [
  {
    text: "Your quality of work and 24/7 support straight-up boosted my sales. Thanks,fam!",
    user: "Shanmuga Priya Baskar, Founder of Saibariya Skin & Haircare",
    img: c1
  },
  {
    text: "Your Agency's work generated significant leads for our business. We highly recommend your services to Other Also. Thank You !",
    user: "A1 Bricks, Coimbatore",
    img: c2
  },
  {
    text: "Your editing style helped me reach a large audience and gain followers quickly. I'm truly grateful!",
    user: "Ram Kumar, Founder of BBQ Mechanic",
    img: c3
  },
   {
    text: "Suberb Edit Bro. Keep Rocking Always",
    user: "Bharath Ganesh, Founder of Social Sphere",
    img: c8
  },
   {
    text: "I've Seen your recent works. Looks Cool Bro",
    user: "Kennet Alphy, Founder of Goat Media",
    img: c9
  },
   {
    text: "Excellent Edit Bro.Thanks for your creative edit bro",
    user: "Founder of Meet my Mentor",
    img: c10
  },

   {
    text: "Thank you Prakash for your hardwork on editing and shooting. Keep Doing More!",
    user: "Sweattha Subramani, CEO at Subramanya Educational Institutions",
    img: c11
  },
];

const testimonialsBottom = [
  {
    text: "Impressed by your on-time delivery and high-quality product shoots. Thank You.",
    user: "Gokul Krishna, Founder of G Krishna Naturals",
    img: c4
  },
  {
    text: "I’ve seen your works and truly loved the creativity and effort you put in. Keep rocking bro, your content always stands out!",
    user: "Ashwin R, Founder of Ashtag",
    img: c5
  },
  {
    text: "Bro, your edits are next level, super clean and engaging. Can’t wait to see where your talent takes you!",
    user: "Sharan Raj Kumar, Founder of Dike DigitalJourney",
    img: c6
  },
  {
    text: "Loved your works bro, Superb",
    user: "Epaphra, Founder of Townscholar",
    img: c7
  },
  {
    text: "Thanks for your promo video brother. Video Excellent ah Vandhuruku",
    user: "Founder of Aiswaryam Oils",
    img: c12
  },

  {
    text: "Pakka va iruku Bro Reel. Thanks for your work team",
    user: "Thufyl, Managing Director of Fathima Jewellery",
    img: c13
  },
  {
    text: "Bro , Excellent Edit. Super ah iruku",
    user: "Dr Thamizhinian , Certified Dermatologist",
    img: c14
  },
  {
    text: "Prakash Our Video Reached 3Million+ Views. Thanks for your team work guys",
    user: "Rajees, Founder of Rajees Makeover",
    img: c15
  },
 
];

const TestimonialSection = () => {
  // Combine all testimonials for mobile carousel
  const allTestimonials = [...testimonialsTop, ...testimonialsBottom];
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    if (!isMobile) return;

    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % allTestimonials.length);
    }, 2100);

    return () => clearInterval(interval);
  }, [allTestimonials.length]);

  return (
    <section className="testimonial-wrapper" id="testimonials">
      <p className="testimonial-badge">Reviews</p>
      <h2 className="testimonial-heading">Real Stories, Real Results</h2>

      {/* Mobile Carousel - Single Card */}
      <div className="mobile-carousel-wrapper">
        {allTestimonials.map((item, index) => {
          const prevIndex = currentIndex === 0 ? allTestimonials.length - 1 : currentIndex - 1;
          return (
            <div
              key={index}
              className={`testimonial-card mobile-card ${
                index === currentIndex ? 'active' : index === prevIndex ? 'prev' : ''
              }`}
            >
              <div className="stars">★★★★★</div>
              <p className="testimonial-text">{item.text}</p>
              <div className="testimonial-user-info">
                <img src={item.img} alt="User avatar" />
                <p className="testimonial-user">{item.user}</p>
              </div>
            </div>
          );
        })}
      </div>

      {/* Desktop Marquee Row 1 */}
      <div className="marquee-wrapper desktop-marquee">
        <div className="marquee-track left">
          {[...testimonialsTop, ...testimonialsTop].map((item, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">★★★★★</div>
              <p className="testimonial-text">{item.text}</p>
              <div className="testimonial-user-info">
                <img src={item.img} alt="User avatar" />
                <p className="testimonial-user">{item.user}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Desktop Marquee Row 2 */}
      <div className="marquee-wrapper desktop-marquee">
        <div className="marquee-track right">
          {[...testimonialsBottom, ...testimonialsBottom].map((item, index) => (
            <div key={index} className="testimonial-card">
              <div className="stars">★ ★ ★ ★ ★</div>
              <p className="testimonial-text">{item.text}</p>
              <div className="testimonial-user-info">
                <img src={item.img} alt="User avatar" />
                <p className="testimonial-user">{item.user}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      
    </section>
  );
};

export default TestimonialSection;